import { useState, useEffect, useCallback } from 'react'
import { fetchBillingDashboardStats } from '../services/billing/dashboardStatsCache'
import logger from '../utils/logger'

const useBillingDashboardData = () => {
  const [stats, setStats] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const fetchStats = useCallback(async (force = false) => {
    try {
      setLoading(true)
      setError(null)
      const data = await fetchBillingDashboardStats({ force })
      setStats(data)
    } catch (err) {
      logger.error('Failed to fetch billing dashboard stats:', err)
      setError('Failed to load billing dashboard data')
    } finally {
      setLoading(false)
    }
  }, [])

  const refetch = useCallback(() => fetchStats(true), [fetchStats])

  useEffect(() => {
    fetchStats()
  }, [fetchStats])

  return { stats, loading, error, refetch }
}

export default useBillingDashboardData
